import { Role } from './roles'

export const AUTHORIZATION_ROLES = [
  Role.ADMIN,
  Role.SUPER_ADMIN,
  Role.PARTNER_ADMIN,
  Role.PARTNER_OWNER,
  Role.PARTNER_STAFF,
] as const

export type AuthorizationRole = (typeof AUTHORIZATION_ROLES)[number]

/**
 * JWT scope strings (cloud:service:operation). Operation is `read` | `write`.
 *
 * - Canvas / Salesforce: mapped in backend `scopeMapping.ts` from permission sets.
 * - Auth0: identity service permissions are injected as claims; platform may include
 *   `all:labra:write` for full product access.
 */
export const APP_SCOPES = [
  'all:labra:write',
  'aws:marketplace:read',
  'aws:marketplace:write',
  'azure:marketplace:read',
  'azure:marketplace:write',
  'gcp:marketplace:read',
  'gcp:marketplace:write',
  'aws:co-sell:read',
  'aws:co-sell:write',
  'azure:co-sell:read',
  'azure:co-sell:write',
  'gcp:co-sell:read',
  'gcp:co-sell:write',
  'all:propensity:read',
  'all:propensity:write',
] as const

export type AppScope = (typeof APP_SCOPES)[number]

const AUTH_ROLE_SET = new Set<string>(AUTHORIZATION_ROLES)
const APP_SCOPE_SET = new Set<string>(APP_SCOPES)

export const isAuthorizationRole = (
  value: string
): value is AuthorizationRole => AUTH_ROLE_SET.has(value)

export const isAppScope = (value: string): value is AppScope =>
  APP_SCOPE_SET.has(value)
